<div class="chart-and-inputs">
  <div class="chart-wrapper">
    <!-- Reserved for chart if needed -->
  </div>

  <div class="aligned-inputs">
    <div class="label-col">
      <div class="row-label">Opportunity %</div>
      <div class="row-label">Yearly Sales ($)</div>
      <div class="row-label">Notes</div>
    </div>

    <div class="input-cols">
      <div class="input-col" *ngFor="let year of yearRange">
        <!-- Opportunity % -->
        <input type="number" [formControl]="getControl('opportunity_' + year)"
               (change)="onOpportunityChange(year)"
               (keydown.enter)="onOpportunityEnter(year, $event)" />

        <!-- Yearly Sales -->
        <input type="text"
               [value]="formatDecimalWithCommas(getControl('sales_' + year).value)"
               disabled placeholder="Yearly Sales" />

        <!-- Notes -->
        <input type="text"
               [formControl]="getControl('notes_' + year)"
               placeholder="Notes"
               (keydown.enter)="onEnter(year, $event)" />
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="button-col">
      <button class="recalculate" (click)="onRecalculate()" [disabled]="isLoading">Validate</button>
      <button class="submit" (click)="onSubmit()" [disabled]="!isValidationSuccessful || isLoading">Submit</button>
      <button class="cancel" (click)="onCancel()">Cancel</button>
    </div>
  </div>

  <!-- Spinner and Messages -->
  <div class="status-container">
    <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" [diameter]="30"></mat-progress-spinner>

    <div *ngIf="successMessage" class="success-message">
      {{ successMessage }}
      <button class="close-btn" (click)="clearMessages()">×</button>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
      <button class="close-btn" (click)="clearMessages()">×</button>
    </div>
  </div>
</div>
